import styled from 'styled-components'
import { theme } from '../../theme/theme'
import { BodyTiny } from '../styles/Typography'
import { SegmentStack, sumBySteps } from './SegmentStack'
import { ChartStep, SeverityByConditionRow } from './type'

const ROW_LABEL_WIDTH = 208

type Props = {
  steps: readonly ChartStep[]
  rows: readonly SeverityByConditionRow[]
  unit: string
  showUnitInline?: boolean
}

export const SeverityByConditionChart = ({ steps, rows, unit, showUnitInline = false }: Props) => {
  const rowsWithTotal = rows.map((row) => ({ ...row, total: row.total ?? sumBySteps(steps, row.values) }))
  const maxTotal = Math.max(...rowsWithTotal.map(({ total }) => total))

  return (
    <RowList>
      {rowsWithTotal.map(({ key, label, values, total }) => (
        <Row key={key}>
          <RowLabel>{label}</RowLabel>
          <BarTrack>
            <SegmentStack
              steps={steps}
              values={values}
              unit={unit}
              widthPercent={maxTotal > 0 ? (total / maxTotal) * 100 : 0}
              showUnitInline={showUnitInline}
            />
            <RowTotal>{total}</RowTotal>
          </BarTrack>
        </Row>
      ))}
    </RowList>
  )
}

const RowList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.medium}px;
`

const Row = styled.div`
  display: grid;
  grid-template-columns: ${ROW_LABEL_WIDTH}px 1fr;
  align-items: center;
  gap: ${theme.spacing.small}px;

  @media screen and (max-width: ${theme.breakpoint.medium}px) {
    grid-template-columns: 1fr;
    gap: ${theme.spacing.tiny}px;
  }
`

const RowLabel = styled(BodyTiny)`
  color: ${theme.color.grey5};
`

const BarTrack = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.small}px;
`

const RowTotal = styled(BodyTiny)`
  color: ${theme.color.grey4};
  font-variant-numeric: tabular-nums;
`
